<template>
  <div class="remotePayDone">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('remoteDone.crumbs.L1')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/main/remotePay' }" replace>{{$t('remoteDone.crumbs.L2')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('remoteDone.crumbs.L3')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="panel">
      <div class="panel-header panel-header__fix">
        <div class="panel-select-group">
          <span class="panel-header__desc">{{$t('remoteDone.panel.title')}}</span>
        </div>
      </div>
      <div class="panel-body fe-panel_body">
        <span class="pay-title">{{$t('remoteDone.msg.title')}}</span>
        <span class="links">{{ link_url }}</span>
        <el-button class="copy_content" @click="handleClipboard(link_url, $event)">{{ $t('remoteDone.msg.copy') }}</el-button>
        <el-button class="send-color" @click="dialogVisible = true">{{$t('remoteDone.msg.send')}}</el-button>
      </div>
    </div>
    
    <div class="panel">
      <div class="panel-header panel-header__fix" style="margin-top:20px;">
        <div class="panel-select-group">
          <span class="panel-header__desc">{{$t('remoteDone.transaction.title')}}</span>
        </div>
      </div>

      <div class="panel-body table-panel_body">
        <el-table :data="formData">
          <el-table-column :label="$t('remoteDone.table.productName')" prop="goods_name"></el-table-column>
          <el-table-column :label="$t('remoteDone.table.quantity')" prop="quantity"></el-table-column>
          <el-table-column :label="$t('remoteDone.table.currency')" prop="currency">
            <template slot-scope="scope">
              {{current[scope.row.currency]}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('remoteDone.table.price')" prop="unit_price"></el-table-column>
          <el-table-column :label="$t('remoteDone.table.totalAmount')" prop="total_price">
            <template slot-scope="scope">
              {{current[form.totalCurrency]}} {{scope.row.total_price}}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="bottom-info">
        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.totalAmount')}}</el-col>
          <el-col :span="19">{{current[form.totalCurrency]}} {{ form.totalAmount }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.customerName')}}</el-col>
          <el-col :span="19">{{ form.customerName }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.customerPhone')}}</el-col>
          <el-col :span="19">{{ form.customerPhone }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.customerEmail')}}</el-col>
          <el-col :span="19">{{ form.customerEmail }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.paymentDeadline')}}</el-col>
          <el-col :span="19">{{ form.paymentDeadline }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.logisticsMode')}}</el-col>
          <el-col :span="19">{{ logisticsModeList[form.logisticsMode] }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.date')}}</el-col>
          <el-col :span="19">{{ form.date }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">{{$t('remoteDone.table.description')}}</el-col>
          <el-col :span="19">{{ form.description }}</el-col>
        </el-row>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      size="tiny">
      <div slot="title" class="dialogTitle">
        <p>{{ $t('remoteDone.msg.send') }}</p>
      </div>
      <div class="dialogContent">
        <div class="shareEmail">
          <img src="./share_email.svg" alt="" @click="shareEail">
          <p>{{ $t('remoteDone.msg.Email') }}</p>
        </div>
        <div class="shareLink">
          <img src="./share_copy_link.svg" alt="" @click="handleClipboard(link_url, $event)">
          <p>{{ $t('remoteDone.msg.copyLink') }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import axios from 'axios'
import config from 'config'
import qs from 'qs'
import { adjustDate } from '../../common/js/util'
export default {
  data () {
    return {
      formData: [],
      form: {},
      link_url: '',
      link_id: '',
      shopName: '',
      shopLogo: '',
      current: {
        // '344': this.$t('remote.form.hkd')
        '344': 'HKD'
      },
      logisticsModeList: {
        '3': this.$t('remote.form.logisticsMode.option1'),
        '2': this.$t('remote.form.logisticsMode.option2'),
        '1': this.$t('remote.form.logisticsMode.option3'),
        '0': this.$t('remote.form.logisticsMode.option4'),
      },
      dialogVisible: false
    }
  },
  created () {
    this.form = JSON.parse(window.sessionStorage.getItem('form'))
    if (this.form.date) {
      this.form.date = adjustDate(this.form.date)
    }
    if (this.form.paymentDeadline) {
      this.form.paymentDeadline = adjustDate(this.form.paymentDeadline)
    }
    this.formData = JSON.parse(window.sessionStorage.getItem('goods_info'))
    this.getGenerateLink()
    this.getShopMsg()
  },
  methods: {
    handleClipboard (text, event) {
      const clipboard = new Clipboard(event.target, {
        text: () => text
      })
      clipboard.on('success', () => {
        this.$message.success(this.$t('remoteDone.msg.copySuccess'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
         this.$message.error(this.$t('remoteDone.msg.copyFail'))
        clipboard.destroy()
      })
      clipboard.onClick(event)
    },
    shareEail () {
      let params
      if (!this.form.customerEmail) {
        this.$message.error(this.$t('remoteDone.msg.promptEmail'))
        return
      } else {
        params = {
          link_url: this.link_url,
          link_id: this.link_id,
          mode: 'email',
          email: this.form.customerEmail,
          format: 'cors'
        }
        this.dialogVisible = false
        axios.post(`${config.oHost}/remotepay/link/pay_link_share`, qs.stringify(params)).then(res => {
          let data = res.data
          if (data.respcd === config.code.OK) {
            this.$message.success(this.$t('remoteDone.msg.sent'))
            this.$router.push({path: '/main/remotePay'})
          } else {
            this.$message.error(data.resperr)
          }
        }) 
      }
    },
    getGenerateLink () {
      this.link_id = this.$route.query.link_id
      axios.get(`${config.oHost}/remotepay/link/pay_link_url`, {
        params: {
          link_id: this.link_id,
          mode: 'url',
          format: 'cors'
        }
      }).then(res => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.link_url = data.data.link_url
        } else {
          this.$message.error(data.resperr)
        }
      })
    },
    getShopMsg () {
      this.link_id = this.$route.query.link_id
      let params = {
        link_id: this.link_id,
        mode: 'share',
        format: 'cors'
      }
      axios.post(`${config.oHost}/remotepay/link/pay_link_share`, qs.stringify(params)).then(res => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.shopName = data.data.storename
          this.shopLogo = data.data.logo_url
        } else {
          this.$message.error(data.resperr)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .remotePayDone {
    .panel {

    }
    .fe-panel_body {
      margin-top: 49px;
      margin-left: 30px;
      padding-bottom: 49px;
      .pay-title {
        width: 143px;
        color: #282B2D;
        font-weight: 600;
      }
      .links {
        margin-left: 10px;
        margin-right: 13px;
        color: #FE9B20;
      }
      .copy_content {
        width: 100px;
      }
      .send-color {
        background:rgba(254,155,32,1);
        border: none;
        width: 100px;
        span {
          color: #FFFFFF;
        }
      }
    }
    .table-panel_body {
      padding: 30px 30px 21px 30px;
      .el-table {
        .el-table__body-wrapper {
          .el-table__row {
            height: 50px;
            td {
              border-bottom: none;
            }
          }
        }
      }
    }
    .bottom-info {
      padding-left: 30px;
      padding-right: 30px;
      font-size: 16px;
      padding-bottom: 30px;
      .el-row {
        line-height: 35px;
        .el-col-5 {
          color: #8A8C92;
        }
      }
    }
    .el-dialog__wrapper {
      .el-dialog {
        width: 500px;
        padding-left: 30px;
        padding-right: 30px;
        box-sizing: border-box;
        .el-dialog__header {
          position: relative;
          padding: 0;
          padding-top: 30px;
          .dialogTitle {
            text-align: center;
          }
          .el-dialog__headerbtn {
            position: absolute;
            top: 21px;
            right: 0px;
          }
        }
        .el-dialog__body {
          padding: 0;
          margin-top: 31px;
          .dialogContent {
            padding-bottom: 30px;
            display: flex;
            .shareEmail {
              width: 75px;
              height: 75px;
              text-align: center;
              margin-right: 37px;
              p {
                margin-top: 10px;
              }
            }
            .shareLink {
              width: 75px;
              height: 75px;
              text-align: center;
              p {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// remotePayDone.vue?57eec0a0